module.exports = __webpack_public_path__ + "img/lestentactrices.5a9d207b.png";